module.exports = __webpack_public_path__ + "static/media/icon／icon_xiajiantou_1414_999999.8eb88ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon／icon_xiajiantou_1414_999999.png
// module id = 1781
// module chunks = 0 1